<app-header-component
  [headerData]="currentHeaderData"
  (closeModal)="closeModal()"
></app-header-component>

<ion-content scrollEvents="true">
  <div *ngIf="!filters; else filterBlock">
    <ion-list
      lines="none"
      *ngFor="let item of skeletonItems"
      class="ion-list-transparent-bg-color"
    >
      <ion-item>
        <ion-label class="fs-4 font500 ion-label-primary-text-color mar-tp-bt">
          <ion-skeleton-text
            animated
            style="width: 40%; height: 20px"
          ></ion-skeleton-text>
        </ion-label>
      </ion-item>

      <ion-item lines="none" *ngFor="let facet of item.facets">
        <div slot="start" class="mart5 marb5 marr10">
          <ion-skeleton-text
            animated
            style="width: 20px; height: 20px; border-radius: 4px"
          ></ion-skeleton-text>
        </div>

        <ion-label
          class="fs-2 font500 mart5 marb5 ion-label-primary-text-color"
        >
          <ion-skeleton-text
            animated
            [style.width]="facet.labelWidth"
            style="height: 16px"
          ></ion-skeleton-text>
        </ion-label>

        <ion-label
          class="fs-2 font500 ion-label-primary-text-color pad5-v"
          slot="end"
        >
          <ion-skeleton-text
            animated
            style="width: 30px; height: 16px"
          ></ion-skeleton-text>
        </ion-label>
      </ion-item>
    </ion-list>
  </div>

  <ng-template #filterBlock>
    <ion-segment
      class="tab-segment"
      [(value)]="selectedSegment"
      mode="md"
      scrollable="true"
    >
      <ion-segment-button
        *ngFor="let filterItem of filters"
        [value]="filterItem.name"
        (click)="onSegmentChange(filterItem.name)"
        class="ion-align-items-center ion-text-capitalize fs-3 font600 l-spacing0"
      >
        {{ filterItem.name }}
      </ion-segment-button>
    </ion-segment>

    <ion-list
      lines="none"
      *ngFor="let filterItem of filters"
      class="ion-list-transparent-bg-color filter-list"
      [id]="filterItem.name"
    >
      <ion-item>
        <ion-label
          class="fs-4 font500 ion-label-primary-text-color ion-no-margin ion-margin-top"
          >{{ filterItem.name }}</ion-label
        >
      </ion-item>

      <div *ngIf="isButtonStyle(filterItem.indexField, filterItem.name)">
        <ion-grid>
          <ion-row>
            <ion-col size="6" *ngFor="let facet of filterItem.facets">
              <ion-button
                expand="block"
                [ngClass]="
                  isSelected(filterItem.indexField, facet.facetKey)
                    ? 'primary-btn'
                    : 'white-btn'
                "
                class="filter-button"
                (click)="
                  toggleButtonFilter(filterItem.indexField, facet.facetKey)
                "
                [disabled]="facet.count <= 0"
              >
                <div
                  class="d-flex w100 ion-justify-content-between ion-align-items-center"
                >
                  <div class="label-container d-flex ion-align-items-center">
                    <div class="icon-wrapper">
                      <img
                        *ngIf="getFacetIcon(facet, filterItem.indexField)"
                        [src]="getFacetIcon(facet, filterItem.indexField)"
                        alt=""
                        class="facet-icon marr6"
                      />
                    </div>
                    <div class="labels-wrapper">
                      <ion-label
                        class="fs-2 font500 ion-label-primary-text-color filter-name"
                      >
                        {{ getTimeOfDayLabel(facet.name) }}
                      </ion-label>
                      <ion-label
                        class="fs-2 font500 ion-label-primary-text-color filter-name"
                      >
                        {{ removeTimeOfDayLabel(facet.name) }}
                      </ion-label>
                    </div>
                  </div>
                  <span
                    *ngIf="!filterItem?.hideFilterCount"
                    [disabled]="facet.count <= 0"
                    class="fs-2 font500 ion-label-primary-text-color"
                    >({{ facet.count }})</span
                  >
                </div>
              </ion-button>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>

      <div *ngIf="!isButtonStyle(filterItem.indexField, filterItem.name)">
        <div
          *ngIf="isSearchable(filterItem)"
          class="search-container ion-padding-horizontal"
        >
          <ion-searchbar
            [(ngModel)]="searchTerms[filterItem.indexField]"
            [placeholder]="'Search ' + filterItem.name"
            (ionFocus)="onSearchFocus(filterItem)"
            (ionBlur)="onSearchBlur(filterItem)"
            (ionClear)="clearSearch(filterItem)"
            class="filter-searchbar"
            mode="ios"
            [debounce]="200"
          ></ion-searchbar>
        </div>

        <div
          class="facets-container"
          [ngClass]="{
            'facets-scrollable':
              searchActive[filterItem.indexField] ||
              searchTerms[filterItem.indexField]
          }"
        >
          <ion-item
            lines="none"
            *ngFor="
              let facet of isSearchable(filterItem)
                ? getFacetsToDisplayWithSearch(filterItem)
                : getFacetsToDisplay(filterItem)
            "
          >
            <ion-checkbox
              class="mart5 marb5 marr10 primary-checkbox"
              slot="start"
              aria-label="agree"
              [checked]="
                isSelected(filterItem.indexField, facet.facetKey || facet.name)
              "
              (ionChange)="
                updateFilter(
                  $event,
                  filterItem.indexField,
                  facet.facetKey || facet.name
                )
              "
              [disabled]="facet.count <= 0"
            ></ion-checkbox>
            <ion-label
              class="fs-2 font500 mart5 marb5 ion-label-primary-text-color"
              >{{ facet.name }}</ion-label
            >
            <ion-label
              *ngIf="!filterItem?.hideFilterCount"
              class="fs-2 font500 ion-label-primary-text-color pad5-v"
              slot="end"
              >({{ facet.count }})</ion-label
            >
          </ion-item>

          <div
            *ngIf="
              searchTerms[filterItem.indexField] &&
              getFacetsToDisplayWithSearch(filterItem).length === 0
            "
            class="no-results ion-padding"
          >
            <ion-label class="fs-2 font500 ion-label-secondary-text-color">
              {{ "bus.filter_modal.no_results_found" | translate }} "{{
                searchTerms[filterItem.indexField]
              }}"
            </ion-label>
          </div>
        </div>

        <div
          class="show-more-container ion-padding-horizontal d-flex ion-align-items-center ion-justify-content-between mart5 marb5"
          *ngIf="
            isSearchable(filterItem)
              ? shouldShowToggleWithSearch(filterItem)
              : shouldShowToggle(filterItem)
          "
          (click)="toggleShowAll(filterItem)"
        >
          <span class="fs-3 font600 show-more-text blue-text-color">
            <ng-container
              *ngIf="expandedFilters[filterItem.indexField]; else showAllLabel"
            >
              {{ "bus.filter_modal.show_less" | translate }}
            </ng-container>
            <ng-template #showAllLabel>
              {{ "bus.filter_modal.show_all" | translate }}
              {{ filterItem?.facets?.length }}
            </ng-template>
          </span>
          <ion-icon
            class="show-more-icon blue-text-color marr5"
            [name]="
              expandedFilters[filterItem.indexField]
                ? 'chevron-up-outline'
                : 'chevron-down-outline'
            "
          ></ion-icon>
        </div>
      </div>
    </ion-list>
  </ng-template>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <div class="footer-btn-container">
      <ion-button
        (click)="resetFilter()"
        class="ion-no-margin outline-btn fs-3 font500 marr8"
      >
        {{ "modals.filter_modal.reset" | translate }}
      </ion-button>
      <ion-button
        (click)="applyFilter()"
        class="ion-no-margin fs-3 font500 primary-btn"
      >
        {{ "modals.filter_modal.apply" | translate }}
      </ion-button>
    </div>
  </ion-toolbar>
</ion-footer>
